var components
try {
  components = {
    "u-Image": function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u--image/u--image" */ "@/uni_modules/uview-ui/components/u--image/u--image.vue"
      )
    },
    uRadioGroup: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-radio-group/u-radio-group" */ "@/uni_modules/uview-ui/components/u-radio-group/u-radio-group.vue"
      )
    },
    uRadio: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-radio/u-radio" */ "@/uni_modules/uview-ui/components/u-radio/u-radio.vue"
      )
    },
    uCheckboxGroup: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-checkbox-group/u-checkbox-group" */ "@/uni_modules/uview-ui/components/u-checkbox-group/u-checkbox-group.vue"
      )
    },
    uCheckbox: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-checkbox/u-checkbox" */ "@/uni_modules/uview-ui/components/u-checkbox/u-checkbox.vue"
      )
    },
    "u-Textarea": function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u--textarea/u--textarea" */ "@/uni_modules/uview-ui/components/u--textarea/u--textarea.vue"
      )
    },
    uButton: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-button/u-button" */ "@/uni_modules/uview-ui/components/u-button/u-button.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-popup/u-popup" */ "@/uni_modules/uview-ui/components/u-popup/u-popup.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 =
    _vm.viewType == 1 && _vm.currentQ.questionType == 2
      ? _vm.__map(_vm.currentQ.content.items, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g0 = _vm.currentB.includes(item.prefix)
          return {
            $orig: $orig,
            g0: g0,
          }
        })
      : null
  var l1 =
    _vm.viewType == 2 && _vm.currentQ.questionType == 2
      ? _vm.__map(_vm.currentQ.content.items, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g1 = _vm.currentQ.answer.includes(item.prefix)
          var g2 =
            _vm.currentB.includes(item.prefix) &&
            !_vm.currentQ.answer.includes(item.prefix)
          return {
            $orig: $orig,
            g1: g1,
            g2: g2,
          }
        })
      : null
  var g3 = _vm.idList.length
  var g4 = _vm.curTotalIndex == _vm.idList.length - 1 && _vm.viewType == 2
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        l1: l1,
        g3: g3,
        g4: g4,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }